/**
 * Merge array2 into array1 inserting one item from array2 at intervals.
 */
export const mergeArraysAtIntervals = <T>(
  array1: T[],
  array2: T[],
  interval: number,
  offset: number = 0
): T[] => {
  const result = [...array1];
  let index = offset;

  while (index < result.length) {
    result.splice(index, 0, ...array2.splice(0, 1));
    index += interval + 1;
  }

  return result;

}